module.exports = __webpack_public_path__ + "img/device-pile.0b3d8214.png";